// Copyright (c) 2020-2021, 2023 Visual Intelligence LP. All rights reserved.
//

// Misc labels
export const TWOFA_DIALOG_TITLE = "Verification";


// Define roles for access control.
export const ROLES = {
  pilot: 'Pilot',
  projectManager: 'ProjectManager',
  observer: 'Observer',
  postProcessingTechnician: 'PostProcessingTechnician',
  productionTechnician: 'ProductionTechnician',
  customerUser: 'CustomerUser',
  techSupport: 'TechSupport',
  contextCaptureClusterAgent: 'ContextCaptureClusterAgent'
};

// lookup table for role labels.
export const ROLES_LABELS = {
  [ROLES.pilot]: 'Pilot',
  [ROLES.projectManager]: 'Project manager',
  [ROLES.observer]: 'Observer',
  [ROLES.postProcessingTechnician]: 'Processing tech',
  [ROLES.productionTechnician]: 'Production tech',
  [ROLES.customerUser]: 'Customer user',
  [ROLES.contextCaptureClusterAgent]: 'ContextCapture cluster agent',
  [ROLES.techSupport]: 'Tech support',
};

export enum ProfileStatus {
  active = 1,
  blocked = 2,
  waitingForConfirmation = 3
}

// Define endorsements and corresponding labels.
export const SPECIAL_ENDORSEMENTS = {
  telecom: 1,
  utilities: 2,
  oilAndGas: 3,
  rail: 4,
  mapping: 5,
  energy: 6,
  aec: 7,
  other: 8
};

export const SPECIAL_ENDORSEMENTS_LABELS = {
  [SPECIAL_ENDORSEMENTS.telecom]: 'Telecom', 
  [SPECIAL_ENDORSEMENTS.utilities]: 'Utilities', 
  [SPECIAL_ENDORSEMENTS.oilAndGas]: 'Oil & Gas', 
  [SPECIAL_ENDORSEMENTS.rail]: 'Rail', 
  [SPECIAL_ENDORSEMENTS.mapping]: 'Mapping', 
  [SPECIAL_ENDORSEMENTS.energy]: 'Energy', 
  [SPECIAL_ENDORSEMENTS.aec]: 'AEC', 
  [SPECIAL_ENDORSEMENTS.other]: 'Other'
};

export const PERMISSIONS = {
  
};

// Properties associated with a user.
export const USER_FIELDS = {
  title: 'title',
  fullName: 'fullName',
  roles: 'roles',
  isBlocked: 'isBlocked',
  twoFactorEnabled: 'twoFactorEnabled',
  isActive: 'isActive',
  profilePhoto: 'profilePhoto',
  licenseNumber: 'licenseNumber',
  licenseIssueDate: 'licenseIssueDate',
  licenseExpirationDate: 'licenseExpirationDate',
  licensePhoto: 'licensePhoto',
  specialEndorsements: 'specialEndorsements',
  baselineFlightTime: 'baselineFlightTime',
  email: 'email',
  lastActivityDate: 'lastActivityDate',
  profileStatus: 'profileStatus',
  id: 'id',
  companyId: 'companyId',
  companyName: 'companyName',
  isHostingCompany: 'isHostingCompany'
};